import { render, staticRenderFns } from "./EtaPontosForm.vue?vue&type=template&id=536bb451&"
import script from "./EtaPontosForm.vue?vue&type=script&lang=js&"
export * from "./EtaPontosForm.vue?vue&type=script&lang=js&"
import style0 from "./EtaPontosForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports